<template>
    <div class="m-portlet m-portlet--head-sm" v-loading="loading">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <div class="m-portlet__head-text">
                        <el-select v-model="filter.section_id" placeholder="请选择校区" @change="handleShow()">
                            <el-option
                                    v-for="item in sections"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>

                        <el-select v-model="filter.grade_id" multiple placeholder="请选择年级" @change="changeGrade">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>

                        <el-button @click="showStudentFuc()">切换</el-button>

                        <small>日期：</small>
                        <el-date-picker
                                v-model="filter.date"
                                type="date"
                                :clearable="false"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                @change="handleShow()">
                        </el-date-picker>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-portlet__body" >
            <div style="position: relative;overflow: hidden;">
                <div class="left cart-type" :style="{'height':clientHeight-96-53.2-45.5-100+'px'}" ref="cartScroll">
                    <canvas ref="cartcanvas"
                            v-on:mousedown="handleCartMousedown"
                            :width="V4leftTimeW+5*V4ratio" :height="row*V4rectH"
                            :style="{'width':V4leftTimeW/V4ratio+5+'px','height':row*V4rectH/V4ratio+'px'}"></canvas>

                </div>
                <div class="right" v-if="V4Judge">
                    <DailyTable ref="V4Table"
                                @handleMouseDown="handleMousedown"
                                @drop="drop"
                                @allowDrop="allowDrop"
                                @handleCellClick="handleCellClick"
                                @cartScroll="cartScroll"
                                v-show="V4Show"></DailyTable>
                </div>
            </div>
        </div>
        <el-dialog
                title="创建特殊"
                :visible.sync="dialogVisible"
                width="950px"
                :before-close="handleClose"
                append-to-body
               >
            <ChooseSpecialClass v-if="dialogVisible"></ChooseSpecialClass>
        </el-dialog>

    </div>

</template>

<script>
    import index from '../../../../TimeTable/Daily/Index'
    import ChooseSpecialClass from './Dialog_CreateSpecialClass'
    export default {
        name: "OperationDaily",
        data() {
            return {
                path: "/timeTable/day",
                loading: true,
                V4Judge: false,
                V4Show: false,
                showStudent: false,
                dialogVisible:false,
                borderColor: '#ededed',
                fillStyle: "#555",
                V4titleW: 100 * window.devicePixelRatio,
                V4titleH: 50 * window.devicePixelRatio,
                V4leftTimeW: 120 * window.devicePixelRatio,
                V4rectW: 100 * window.devicePixelRatio,
                V4rectH: 60 * window.devicePixelRatio,
                V4ratio: window.devicePixelRatio,
                startPoint: {
                    x: 1,
                    y: 1
                },
                //subscribe
                grades: {},
                class_types:{},
                sections: {},
                classes: {},
                timeData: {},
                basisTime: {},
                subjects: {},
                teachers: {},
                class_student: {},
                date: '',
                tempLength: 0,

                classrooms: {},
                scroll: {
                    left: 0,
                    top: 0
                },
                filter: {
                    semester_id: this.$store.state.config.nowSemester.id,
                    section_id: this.$store.state.config.section.id,
                    grade_id: [],
                    date: this.$moment().format('YYYY-MM-DD')
                },
                dialogData:{
                    subject_id:'',
                    teacher_id:'',
                    subject_name:'',
                    teacher_name:'',
                    classHeight:'',
                    start_time:'',
                    time:0,
                    date:'',
                    width:600,
                },
                classx: '',
                classForm: {},

                //每日课表组件
                ops: {
                    rail: {
                        size: '3px',
                        gutterOfSide: '5px'
                    },
                    bar: {
                        keepShow: true,
                        background: 'rgba(144, 147, 153, 0.3)'
                    }
                },
                ctx: '',
                timeCtx: '',
                V4cell: {
                    selectable: false,
                    subject_id: '',
                    teacher_id: '',
                    startSort: 0,
                },

                scrollLeft: 0,
                scrollTop: 0,
                startTime: 8,
                endTime: 23,
                type: 'dayTimeTable_cart',

                create_special_button_loading:false,
                studentCarts: {},
            }
        },
        components: {
            'DailyTable': index,
            'ChooseSpecialClass': ChooseSpecialClass,
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            powers(){
                return this.$store.state.config.powers;
            },
            list() {
                let length = 0;
                for (let subject_id in this.subjects) {
                    if (this.teachers[subject_id]) {
                        length += Object.keys(this.teachers[subject_id]).length
                    }
                }
                return length;
            },
            row() {
                let length = 0;
                for (const key in this.basisTime) {
                    if (key > this.startTime && key < this.endTime) {
                        length++;
                    }
                }
                return length
            },
            orderStudentCarts: function () {
                return this._.orderBy(this.studentCarts, 'sortBy', 'asc');
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$wApi.addListen(this.path, this.handleData);
            this.$wApi.addListen('/student/' + this.$parentInfo.student.id, this.handleStudentData);
            this.handleShow()
        },
        mounted(){
            const canvas = this.$refs.cartcanvas;
            this.ctx = canvas.getContext('2d')
        },
        destroyed(){
            this.$wApi.removeListen(this.path);
        },
        methods: {
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'show':
                        this.sections = data.sections;
                        this.grades = data.grades;
                        this.timeData = data.timeData;
                        this.subjects = data.subjects;
                        this.teachers = data.teachers;
                        this.classes = data.classes;
                        this.basisTime = data.basisTime;
                        this.class_types = data.class_types;
                        this.classrooms = data.classrooms;
                        this.class_student = data.class_student;
                        this.filter.date = data.filter.date;
                        this.tempLength = data.tempLength;
                        this.V4Show = true;
                        this.loading = false;
                        this.V4Judge = true;
                        setTimeout(()=>{
                            if(this.V4Judge){
                                this.$refs.V4Table.initCanvas()

                            }
                        },100);
                        break;
                    case 'class_update':
                        if (this.filter.date == data.old_date) {
                            if (this.classes[data.old_teacher_id]) {
                                for (let key in this.classes[data.old_teacher_id]) {
                                    if (this.classes[data.old_teacher_id][key].class_plan_id == data.classPlan_id) {
                                        this.classes[data.old_teacher_id].splice(key, 1)
                                        this.$refs.V4Table.initCanvas()
                                        break;
                                    }
                                }
                            }
                        }
                        if (this.filter.date == data.classPlan.date) {
                            if (this.classes[data.classPlan.teacher_id]) {
                                this.classes[data.classPlan.teacher_id].push(data.classPlan);

                            } else {
                                this.classes[data.classPlan.teacher_id] = [data.classPlan]
                            }
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.$refs.V4Table.initCanvas()
                        }
                        this.$refs.V4Table.paintCache();
                        break;
                    case 'store_specialClass':
                        this.create_special_button_loading=false
                        if (this.filter.date == data.classPlan.date) {
                            if (this.classes[data.classPlan.teacher_id]) {
                                this.classes[data.classPlan.teacher_id].push(data.classPlan);
                            } else {
                                this.classes[data.classPlan.teacher_id] = [data.classPlan]
                            }
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.V4cell.selectable = true;
                            this.$refs.V4Table.initCanvas()
                        }
                        this.dialogVisible=false;
                        this.$refs['V4Table'].cell.visible = false;
                        break;
                    case 'drop_class':
                        for (let key in data.old_timeTable ) {
                            if(this.filter.date==data.old_timeTable[key].date && this.filter.section_id==data.old_timeTable[key].section_id){
                                if(this.classes[data.old_timeTable[key].teacher_id]){
                                    for(let key1 in this.classes[data.old_timeTable[key].teacher_id]){
                                        if(this.classes[data.old_timeTable[key].teacher_id][key1].class_plan_id==data.old_timeTable[key].class_plan_id){
                                            this.classes[data.old_timeTable[key].teacher_id].splice(key1,1)
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        for (let key2 in data.new_timeTable ) {
                            if (this.filter.date ==data.new_timeTable[key2].date && this.filter.section_id ==data.new_timeTable[key2].section_id) {
                                if (this.classes[data.new_timeTable[key2].teacher_id]) {
                                    this.classes[data.new_timeTable[key2].teacher_id].push(data.new_timeTable[key2]);
                                } else {
                                    this.classes[data.new_timeTable[key2].teacher_id] = [data.new_timeTable[key2]]
                                }

                            }
                        }
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        break;
                    case 'create_class':
                        for (let key in data.timeTable_days ) {
                            if (this.filter.date ==data.timeTable_days[key].date && this.filter.section_id ==data.timeTable_days[key].section_id) {
                                if (this.classes[data.timeTable_days[key].teacher_id]) {
                                    this.classes[data.timeTable_days[key].teacher_id].push(data.timeTable_days[key]);
                                } else {
                                    this.classes[data.timeTable_days[key].teacher_id] = [data.timeTable_days[key]]
                                }
                            }
                        }
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        break;
                }
            },
            handleStudentData(event, data) {
                switch (event) {
                    case 'get_student_carts_to_dayTimeTable':
                        this.studentCarts = data.studentCarts;
                        setTimeout(() => {
                            this.paintCart(this.ctx);
                        }, 100);
                        break;
                    case 'add_class_to_specialCart':
                        this.$set(this.studentCarts, data.studentCart.id, data.studentCart);
                        this.paintCart(this.ctx);
                        break;
                    case 'delete_cart_to_specialCart':
                        this.$delete(this.studentCarts, data.cart_id);
                        this.paintCart(this.ctx);
                        break;
                }
            },
            changeGrade(){
                for(let subject_id in this.teachers){
                    for (let key in this.teachers[subject_id]) {
                        var teacherGrades=this.teachers[subject_id][key].grades
                        let union = teacherGrades.filter(v => this.filter.grade_id.includes(v))
                        if(union.length==0 && this.filter.grade_id.length>0){
                            this.teachers[subject_id][key].view=false;
                        }else{
                            this.teachers[subject_id][key].view=true;
                        }
                    }
                }
                var start=0;
                this.tempLength=0;
                for(let key1 in this.subjects){

                    let teacherView=0;
                    for (let teacher_id in this.teachers[key1]) {
                        if(this.teachers[key1][teacher_id].view){
                            teacherView+=1;
                        }
                    }
                    if(teacherView==0 &&  this.filter.grade_id.length==0){
                        teacherView=1;
                    }

                    this.subjects[key1].dataLength=teacherView
                    this.subjects[key1].rect=[this.tempLength+start*0.1,0,teacherView,1]
                    this.tempLength+=teacherView;
                    if(teacherView==0){
                        this.subjects[key1].view=false;
                    }else{
                        this.subjects[key1].view=true;
                        start=start+1;
                    }
                }
                setTimeout(()=>{
                    this.$refs.V4Table.initCanvas();
                },100)
            },
            //开画
            drawLine(ctx, start = [0, 0], end = [0, 0], lineDash = []) {
                let x = this.startPoint.x;
                let y = this.startPoint.y;
                ctx.beginPath();
                ctx.setLineDash(lineDash);
                ctx.moveTo(start[0] + x, start[1] + y);
                ctx.lineTo(end[0] + x, end[1] + y);
                ctx.stroke()
            },
            getFontStyle(size, lineHeight) {
                return 'normal ' + size * this.V4ratio + 'px/' + lineHeight * this.V4ratio + 'px  Microsoft YaHei';
            },
            paintCart(ctx) {

                ctx.clearRect(0, 0, this.V4leftTimeW, this.row * this.V4rectH);

                ctx.lineWidth = 2 * this.V4ratio;

                ctx.font = this.getFontStyle(12, 12);
                ctx.fillStyle = this.fillStyle;
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                for (let key in this.studentCarts) {
                    var studentCart=this.studentCarts[key];
                    if (this.filter.grade_id.length !== 0) {
                        if (this.filter.grade_id.includes(studentCart.grade_id)) {
                            ctx.fillStyle = studentCart.color;
                        } else {
                            ctx.fillStyle = '#ededed';
                        }
                    } else {
                        if (![3, 6].includes(studentCart.class_type_id)) {
                            ctx.fillStyle = '#FF0000';
                        } else {
                            ctx.fillStyle = studentCart.color;
                        }
                    }

                    ctx.globalAlpha = 0.05;
                    ctx.fillRect(0, (studentCart.start_sort - this.startTime) * this.V4rectH, this.V4leftTimeW, (studentCart.end_sort - studentCart.start_sort) * this.V4rectH);
                    ctx.fillStyle = this.fillStyle;
                    ctx.globalAlpha = 1;
                    ctx.fillText(studentCart.class_name, this.V4leftTimeW / 2, (studentCart.start_sort - this.startTime) * this.V4rectH +  (studentCart.end_sort - studentCart.start_sort) * this.V4rectH/ 2)
                }

                ctx.strokeStyle = this.borderColor;
                this.drawLine(ctx, [0, 0], [this.V4leftTimeW, 0], []);
                for (let i = 0; i < 2; i++) {
                    this.drawLine(ctx, [(this.V4leftTimeW) * i, 0], [(this.V4leftTimeW) * i, this.V4rectH * this.row], []);
                }
                ctx.stroke()

            },
            handleShow() {
                this.loading = true;
                this.$wApi.send(this.path, 'show', {'date': this.filter.date, 'section_id': this.filter.section_id});

                this.$wApi.send('/student/' + this.$parentInfo.student.id, 'get_student_carts_to_dayTimeTable', {
                    'date': this.filter.date,
                    'student_id': this.$parentInfo.student.id,
                    'section_id': this.filter.section_id
                });

                this.V4Show = false;
            },
            //点击
            handleCellClick(evt) {
                if (this.V4cell.selectable) {
                    if (this.classes[this.V4cell.teacher_id]) {
                        for (var key in this.classes[this.V4cell.teacher_id]) {
                            if (this.classes[this.V4cell.teacher_id][key].start_sort - this.startTime == this.V4cell.startSort) {
                                this.$wApi.send('/student/' + this.$parentInfo.student.id, 'add_class_to_specialCart', {
                                    'class_id': this.classes[this.V4cell.teacher_id][key].class_id,
                                    'class_plan_id': this.classes[this.V4cell.teacher_id][key].class_plan_id,
                                    'student_id': this.$parentInfo.student.id,
                                });
                            }
                        }
                    }
                }else{
                    this.dialogData={
                        subject_id:this.V4cell.subject_id,
                        teacher_id:this.V4cell.teacher_id,
                        subject_name:this.subjects[this.V4cell.subject_id].name,
                        teacher_name:this.teachers[this.V4cell.subject_id][this.V4cell.teacher_id].name,
                        classHeight:this.$refs.V4Table.cell.classHeight,
                        time:this.$refs.V4Table.cell.classHeight*60,
                        start_time:evt.start_time,
                        date:this.filter.date,
                    };
                    this.dialogVisible=true;
                }
            },
            handleCartMousedown(evt) {
                const y = evt.offsetY * this.V4ratio
                const py = parseFloat((y / this.V4rectH).toFixed(1));
                for (let key in  this.studentCarts) {
                    if((this.studentCarts[key].start_sort - this.startTime)<=py && (this.studentCarts[key].end_sort - this.startTime)>=py){
                        this.$wApi.send('/student/'+this.$parentInfo.student.id,'delete_cart_to_specialCart',{
                            'cart_id':this.studentCarts[key].id,
                            'student_id': this.$parentInfo.student.id
                        });
                    }
                }

            },
            deleteClassToCart(cart_id, template_time_id) {
                this.$wApi.send('/student/' + this.$student.id, 'delete_cart', {
                    'cart_id': cart_id,
                    'student_id': this.$parentInfo.student.id,
                    'template_time_id': template_time_id
                });
            },
            handleMousedown(evt) {
                if (evt.type == 'class') {
                    this.V4cell.subject_id = evt.subject_id;
                    this.V4cell.teacher_id = evt.teacher_id;
                    this.V4cell.startSort = evt.startSort;
                    this.V4cell.selectable = true;
                } else {
                    this.V4cell.subject_id = evt.subject_id;
                    this.V4cell.teacher_id = evt.teacher_id;
                    this.V4cell.startSort = 0;
                    this.V4cell.selectable = false;
                }
            },
            handleCanvaClick($event) {
                this.cacheData.selectable = true;
            },
            drop: function (evt) {
                this.$wApi.send(this.path, 'class_update', {
                    'classPlan_id': evt.origin.classPlan_id,
                    'teacher_id': evt.next.teacher_id,
                    'date': this.filter.date,
                    'type': evt.origin.type,
                    'time': evt.next.time,
                    'duration': evt.origin.classHeight,
                    'classroom_id': evt.origin.classroom_id,
                    'remark': evt.origin.remark,
                });
            },
            allowDrop: function (event) {
                event.preventDefault();
                return true;
            },
            showStudentFuc() {
                this.showStudent = this.showStudent ? false : true;
                if (this.showStudent) {
                    this.$refs['V4Table'].V4rectH = 200 * window.devicePixelRatio;
                    this.$refs['V4Table'].V4divi = 8;

                } else {
                    this.$refs['V4Table'].V4rectH = 50 * window.devicePixelRatio;
                    this.$refs['V4Table'].V4divi = 2;

                }
                this.$nextTick(function () {
                    this.$refs['V4Table'].cell.visible = false;
                    this.$refs.V4Table.initCanvas()
                })
            },
            cartScroll(scrollTop) {
                this.$refs.cartScroll.scrollTop = scrollTop;
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }
        }
    }
</script>

<style scoped lang="scss">
    .scell {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        width: 100px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
    }

    .dragging {
        cursor: pointer !important;
    }

    .left {
        float: left;
        width: 125px;
    }

    .cart-type {
        position: absolute;
        top: 100px;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .cart-item {
        border: 2px solid #ededed;
        border-bottom: none;
        height: 50px;
        font-size: 13px;
        line-height: 25px;
        text-align: center;
        &:last-of-type {
            height: 52px;
            border-bottom: 2px solid #ededed;
        }
    }

    .right {
        margin-left: 130px;
    }


</style>
